import Vue from 'vue';
import axios from 'axios';

export default {
  SET_API_DATA: (state, { data }) => {
    if (data.page) {
      state.page = data.page;
    } else {
      state.page = data;
    }
  },

  SET_USER: (state, { data }) => {
    state.user = data;
  },

  SET_CONTEXT: (state, { data }) => {
    state.context = data;
  },

  SET_NEXT_PAGE: (state, { args }) => {
    let key = args.key;
    let newData = args.data.page || args.data;

    if (!newData) {
      state.page.next_page = false;
      return;
    }

    if (!state.page[key]) {
      return;
    }

    // If using laravel pagination
    if (newData[key].data && newData[key].current_page && newData[key].last_page) {
      state.page[key].data = state.page[key].data.concat(newData[key].data);
      state.page.next_page = newData[key].current_page < newData[key].last_page;

      return;
    }

    state.page[key] = state.page[key].concat(newData[key]);
    state.page.next_page = newData.next_page;
  },

  SET_CART: (state, data) => {
    state.cart = data;
  },

  SET_NOTIFICATIONS: (state, { data }) => {
    state.context.notification_count = data.notification_count;
    state.context.notification_total_count = data.notification_total_count;
  },

  SET_SIDEBAR: (state, { data, key }) => {
    state.sidebar[key] = data;
  },

  SET_SIDEBAR_CACHE: (state, { data }) => {
    state.sidebar.lastUpdate = data;
  },

  SET_RESET_DATA: (state, { data, args }) => {
    let key = args.key;
    let newData = data.page[key];

    if (!newData) {
      state.page.page_number = null;
      return;
    }

    if (!state.page[key]) {
      return;
    }

    state.page[key] = newData;
    state.page.page_number = data.page.page_number;
  },
};



// WEBPACK FOOTER //
// ./src/js/store/mutations.js